import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import CartIcon from "../assets/cart-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import Heart from "../assets/heart.svg";
import {
  fetchAllProductsData,
  loadingError,
  loadingState,
  loadProducts,
} from "../store/slices/productSlice";
import {
  fetchCartItems,
  fetchCartItemsData,
  fetchCartItemsError,
  loadCartitems,
} from "../store/slices/cartSlice";
import { fetchData } from "../store/middleware/api";

export default function Header() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(
    //   fetchData({
    //     url: "products",
    //     onStart: loadingState.type,
    //     onSuccess: loadProducts.type,
    //     onError: loadingError.type,
    //   })
    // );

    // dispatch(
    //   fetchData({
    //     url: "carts/5",
    //     onStart: fetchCartItems.type,
    //     onSuccess: loadCartitems.type,
    //     onError: fetchCartItemsError.type,
    //   })
    // );
    dispatch(fetchAllProductsData())
    dispatch(fetchCartItemsData());

    // dispatch(loadingState());
    // fetch("https://fakestoreapi.com/products")
    //   .then((res) => {
    //     if (!res.ok) {
    //       throw new Error("Failed to fetch products. Please try again later.");
    //     }
    //     return res.json();
    //   })
    //   .then((data) => {
    //     dispatch(loadProducts(data));
    //   })
    //   .catch((err) => {
    //     dispatch(loadingError(err.message));
    //   });
    // dispatch(fetchCartItems());
    // fetch("https://fakestoreapi.com/carts/5")
    //   .then((res) => {
    //     if (!res.ok) {
    //       throw new Error("Failed to fetch products. Please try again later.");
    //     }
    //     return res.json();
    //   })
    //   .then((data) => {
    //     dispatch(loadCartitems(data));
    //   })
    //   .catch((err) => {
    //     dispatch(fetchCartItemsError(err.message));
    //   });
  }, [dispatch]);

  const cartItems = useSelector((state) => state.cartItems.list);
  //   console.log(cartItems)
  const wishlist = useSelector((state) => state.wishList);
  //   console.log(wishlist)
  return (
    <header>
      <div className="header-contents">
        <h1>
          <Link to="/">Mart</Link>
        </h1>
        <div>
          <Link className="cart-icon" to="/wish">
            <img className="heart" src={Heart} alt="heart-icon" />
            <div className="cart-items-count">{wishlist.length}</div>
          </Link>
          <Link className="cart-icon" to="/cart">
            <img src={CartIcon} alt="cart-icon" />
            <div className="cart-items-count">
              {cartItems.reduce((acc, curr) => {
                return acc + curr.quantity;
              }, 0)}
            </div>
          </Link>
        </div>
      </div>
    </header>
  );
}
